// extracted by mini-css-extract-plugin
var _1 = "tjs-mobile-menu-item__icon";
var _2 = "tjs-mobile-menu-item__link tjs-_buttons__btn";
var _3 = "tjs-mobile-menu-item__root";
export { _1 as "icon", _2 as "link", _3 as "root" }
export default { "icon": _1, "link": _2, "root": _3 }
